import { Box, Grid, GridItem } from '@chakra-ui/react';
import React from 'react';

import {
  DigitalMonthlyReportSidebar,
  DigitalMonthlyReportTab,
} from './DigitalMonthlyReportSidebar';

type DigitalMonthlyReportTemplateProps = {
  selectedTab: DigitalMonthlyReportTab;
  setSelectedTab: React.Dispatch<React.SetStateAction<DigitalMonthlyReportTab>>;
  portfolioCovenantKeys: string[] | null;
  borrowingBaseReportId: string | null;
  children: React.ReactNode;
};
export const DigitalMonthlyReportTemplate = ({
  selectedTab,
  setSelectedTab,
  portfolioCovenantKeys,
  borrowingBaseReportId,
  children,
}: DigitalMonthlyReportTemplateProps) => {
  return (
    <Box>
      <Grid templateColumns="repeat(6, 1fr)">
        <GridItem colSpan={1}>
          <DigitalMonthlyReportSidebar
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            portfolioCovenantKeys={portfolioCovenantKeys}
            borrowingBaseReportId={borrowingBaseReportId}
          />
        </GridItem>
        <GridItem colSpan={5} pl="40px">
          {children}
        </GridItem>
      </Grid>
    </Box>
  );
};
